import React from 'react';
import PropTypes from 'prop-types';
import css from './UpcomingLocation.css';
import Icon from 'SF/MaterialIcon';

export default class UpcomingLocation extends React.Component {
  render() {
    return (
      <div className={css['location-container']}>
        <div><Icon aria-label="Location" title="Location" icon="location_on" /></div>
        <div>
          <div className="name">{this.props.name}</div>
          <div className="instructions">{this.props.instructions}</div>
        </div>
      </div>
    );
  }
}

UpcomingLocation.propTypes = {
  name: PropTypes.string.isRequired,
  instructions: PropTypes.string
};
